import { FC } from "react";

import { FormLocation, FormLocationProps } from "@/forms-design-system/FormLocation";

type ThemedTicketingFormLocationProps = Omit<FormLocationProps, "title" | "subtitle"> & {
  street: string;
  cityStateZip: string;
  latitude?: number;
  longitude?: number;
};

export const ThemedTicketingFormLocation: FC<ThemedTicketingFormLocationProps> = ({
  latitude,
  longitude,
  street,
  cityStateZip,
  ...rest
}) => {
  const googleMapsLink = latitude && longitude ? `https://www.google.com/maps?q=${latitude},${longitude}` : undefined;

  return (
    <FormLocation
      title={street}
      subtitle={cityStateZip}
      href={googleMapsLink}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    />
  );
};
